import React, { useMemo } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels, Title);
function PieChartComponent({
    dataValues = [],
    labels = [],
    label,
    title,
    backgroundColor,
}) {
    const data = {
        labels: labels,
        datasets: [
            {
                label: label,
                data: dataValues,
                backgroundColor: backgroundColor,
                borderColor: backgroundColor,
                borderWidth: 1,
            },
        ],
    };

    const options = useMemo(() => {
        return {
            responsive: true,
            plugins: {
                title: {
                    display: true,
                    text: title,
                    font: { size: 20 },
                    position: "bottom",
                },
                legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                        color: "black",
                        padding: 30,
                    },
                },
                tooltip: {
                    callbacks: {
                        label: (tooltipItem) => {
                            const total =
                                tooltipItem.chart.data.datasets[0].data.reduce(
                                    (acc, curr) => acc + curr,
                                    0
                                );
                            const percentage =
                                ((tooltipItem.raw / total) * 100).toFixed(2) +
                                "%";

                            return `${tooltipItem.label}: ${tooltipItem.raw} (${percentage})`;
                        },
                    },
                },
                datalabels: {
                    font: {
                        size: 20,
                    },
                    color: "white",
                    formatter: (value, context) => {
                        const total =
                            context.chart.data.datasets[0].data.reduce(
                                (acc, curr) => acc + curr,
                                0
                            );
                        const percentage =
                            ((value / total) * 100).toFixed(1) + "%";
                        return `${percentage}`;
                    },
                    anchor: "center",
                    align: "center",
                },
            },
        };
    }, [title]);
    return (
        <div>
            <Pie data={data} options={options} />
        </div>
    );
}

const PieChart = React.memo(PieChartComponent);

export default PieChart;